import { render, staticRenderFns } from "./LoadingIndicatorFullPage.vue?vue&type=template&id=bb283352&scoped=true&"
import script from "./LoadingIndicatorFullPage.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicatorFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb283352",
  null
  
)

export default component.exports